import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pipe, map, uniqBy, sortBy } from 'ramda';
import { fetchCountries } from 'products/nomad_insurance/state/countries';

const useCurrencies = () => {
  const dispatch = useDispatch();
  const { countries } = useSelector((state) => state.nomadInsurance.countries);

  useEffect(() => {
    if (!countries?.length) {
      dispatch(fetchCountries());
    }
  }, [dispatch]);

  const formatLabel = (currency) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      currencyDisplay: 'name'
    });
    const unCapitalisedLabel = formatter
      .format(0)
      .replace(/[0-9]|\.|\)|\(/g, '')
      .trim();
    return unCapitalisedLabel.charAt(0).toUpperCase() + unCapitalisedLabel.slice(1);
  };

  const currencies = useMemo(() => {
    if (!countries) return [];
    return pipe(
      map((country) => ({
        label: formatLabel(country.currency),
        value: country.currency
      })),
      uniqBy((country) => country.label),
      sortBy((country) => country.label)
    )(countries);
  }, [countries]);

  return currencies;
};
export default useCurrencies;
